// Single-flight access-token refresh (API-40, AP-D4). When an access token expires,
// concurrent requests must not each fire their own refresh; the first starts one
// refresh and the rest await the same in-flight promise, then retry with the new
// token. Web keeps the refresh token in an HttpOnly cookie, mobile in secure
// storage — both are hidden behind the injected `refresh` function. No Node APIs.

export type RefreshFn = () => Promise<string | null>;

export interface SingleFlightRefresh {
  // Returns the shared in-flight refresh, starting one if none is running.
  run(): Promise<string | null>;
  inFlight(): boolean;
}

export function createSingleFlightRefresh(refresh: RefreshFn): SingleFlightRefresh {
  let pending: Promise<string | null> | null = null;

  return {
    run() {
      if (!pending) {
        pending = Promise.resolve()
          .then(refresh)
          .finally(() => {
            pending = null;
          });
      }
      return pending;
    },
    inFlight() {
      return pending !== null;
    },
  };
}
